/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coveradjustfailed2Inputs */

const en_coveradjustfailed2 = /** @type {(inputs: Coveradjustfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This picture can't be edited.`)
};

const de_coveradjustfailed2 = /** @type {(inputs: Coveradjustfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Bild lässt sich nicht bearbeiten.`)
};

/**
* | output |
* | --- |
* | "This picture can't be edited." |
*
* @param {Coveradjustfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coveradjustfailed2 = /** @type {((inputs?: Coveradjustfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coveradjustfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coveradjustfailed2(inputs)
	return de_coveradjustfailed2(inputs)
});
export { coveradjustfailed2 as "coverAdjustFailed" }